import { memo } from "react";

import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { RenderGroupRowCellProps } from ".";
import IacManagementGroupCell from "../../components/Table/Row/Group/Cell";

const IacManagementTableGroupRowCellResourceAddress = memo((props: RenderGroupRowCellProps) => {
  return (
    <IacManagementGroupCell {...props}>
      <TableCellEmpty />
    </IacManagementGroupCell>
  );
});

IacManagementTableGroupRowCellResourceAddress.displayName =
  "IacManagementTableGroupRowCellResourceAddress";

export default IacManagementTableGroupRowCellResourceAddress;
